import ActionButton from "./ActionButton.tsx";
import { Trans } from "@lingui/react/macro";
import { AlertCircle } from "lucide-react";

interface ErrorStateProps {
  message?: string;
  onGoBack?: () => void;
}

export default function ErrorState({ message, onGoBack }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <AlertCircle className="text-soluud-text-tertiary mb-4 h-10 w-10" />
      <p className="text-soluud-text-primary mb-1 text-base font-medium">
        <Trans>Oops, something went wrong.</Trans>
      </p>
      <p className="text-soluud-text-secondary mb-6 max-w-md text-sm">
        {message || <Trans>Please try again later.</Trans>}
      </p>
      {onGoBack && (
        <ActionButton onClick={onGoBack} variant="secondary" type="button">
          <Trans>Go Back</Trans>
        </ActionButton>
      )}
    </div>
  );
}
